import React from 'react';
import { useField } from 'formik';

interface WhatsAppInputProps {
    label: string;
    name: string;
    mandatory?: boolean;
    classes?: string;
}

const WhatsAppInput: React.FC<WhatsAppInputProps> = ({ label, name, mandatory = false, classes }) => {
    const [field, meta] = useField(name);

    return (
        <tr>
            <th>
                {mandatory && <span>*</span>}
                {label}:
            </th>
            <td style={{ verticalAlign: 'middle' }}>
                <input
                    {...field}
                    id={name}
                    type="text"
                    autoComplete="off"
                    className={`text ${classes}`}
                />
                <a href={`https://wa.me/${field.value}`} style={{ verticalAlign: 'middle', display: 'inline-block' }}><img src="/gfx/whatsapp.png" alt="WhatsApp Logo" width={25} height={25} /></a>
                {meta.touched && meta.error ? (
                    <div className="error">{meta.error}</div>
                ) : null}
            </td>
        </tr>
    );
};

export default WhatsAppInput;